import { getResponseMessage } from './response-envelope';

export type RequestErrorLike = {
  name?: string;
  message?: string;
  info?: {
    errorCode?: number;
    errorMessage?: string;
  };
  response?: {
    status?: number;
    data?: any;
  };
};

export type NormalizedRequestError = {
  status?: number;
  message: string;
  original: unknown;
};

export const normalizeRequestError = (
  error: RequestErrorLike,
): NormalizedRequestError => {
  if (error.name === 'BizError') {
    return {
      // 只有真实 HTTP 401 才表示登录会话失效。业务错误码可能复用 401，
      // 不能据此清理会话并跳转 SSO。
      status: error.response?.status,
      message: error.info?.errorMessage || error.message || '请求失败',
      original: error,
    };
  }

  if (error.response) {
    const status = error.response.status;
    const responseMessage = getResponseMessage(error.response.data);
    return {
      status,
      message:
        responseMessage || (status ? `请求失败 (${status})` : '请求失败'),
      original: error,
    };
  }

  return {
    message: error.message || '请求错误，请重试',
    original: error,
  };
};
